import casusBackend, {CasusInResponse} from '@lexian/api/casus-api';

import {TimeEntryCasus} from '../timetracker.types';

// TODO LEXIAN-8260: load displayName directly when loading time entries
export async function createTimeEntryCasus(
  casusId: string
): Promise<TimeEntryCasus> {
  const casus = await loadCasus(casusId);
  return {
    id: casusId,
    displayName: casus.displayNameWithClient,
  };
}

function loadCasus(casusId: string): Promise<CasusInResponse> {
  return new Promise<CasusInResponse>((resolve) => {
    casusBackend.getCasus({
      parameters: {casusId},
      onSuccess: ({body}) => {
        resolve(body.casus);
      },
    });
  });
}
